import React from 'react';
import { SvgProps } from '../icon.types';

function RainAndWindIcon({ fillColor = '#2D3049' }: SvgProps) {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg">
      <defs />
      <path
        d="M20.6694 2.0111l1.415 1.414-18.574 18.575-1.415-1.414 18.574-18.575zm.0116 11.989l1.415 1.414-5.587 5.587-1.414-1.414 5.586-5.587zm.0003-6.0007l1.415 1.415-11.314 11.314-1.414-1.414 11.313-11.315zM3.681 13.0002l1.415 1.414-1.682 1.682L2 14.6812l1.681-1.681zm11.0009-11l1.414 1.414-9.586 9.586-1.414-1.414 9.586-9.586zm-6.0003 0l1.414 1.414-5.999 6-1.415-1.415 6-5.999z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { RainAndWindIcon };
